import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const SinglePerPageIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M6,2A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8L14,2Zm7,7V3.5L18.5,9Z" />
    </g>
  </SvgIcon>
);

export default SinglePerPageIcon;
